module.exports = __webpack_public_path__ + "img/img_covertack_heart.cebb5f2c.png";